<template>
  <div  id="setting_dialog_outer">
    <div>
      <a class="close-button" href="javascript:void(null);" @click="closeDialog">
        <img src="../../assets/shl_personal_setting_close.png">
      </a>
      <div id="phone_dialog">
        <div class="dialog-title" :style="{color: themeColor}">
          {{user.mobile == null ? '绑定手机号' : '更换手机号'}}
        </div>

        <div class="dialog-content">
          <input class="input-text" type="password"
                 placeholder="请输入密码，认证账号！"
                 v-model="userPwd"
                 :style="{borderColor: themeColor}">

          <input class="input-text" type="text"
                 placeholder="请输入新手机号"
                 v-model="userPhone"
                 :style="{borderColor: themeColor}">

          <div class="input-code-outer">
            <input class="input-code" type="text"
                   placeholder="请输入验证码"
                   v-model="userCode"
                   :style="{borderColor: themeColor}">
            <input
              v-if="codeSecond <= 0"
              class="input-button" type="button"
              value="获取验证码"
              @click="codeButtonClicked"
              :style="{backgroundColor: themeColor}">
            <input
              v-else
              class="input-button" type="button"
              :value="codeSecond + '秒后重试'"
              disabled
              :style="{backgroundColor: '#ddd', color: '#999'}">
          </div>

          <input class="input-button" type="button"
                 value="提交"
                 @click="submitButtonClicked"
                 :style="{backgroundColor: themeColor}">
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: "BingPhoneNumber",
  props: [
    'phone',
    'theme'
  ],
  data() {
    return {
      title: '绑定手机号',
      userPwd: '',
      userPhone: '',
      userCode: '',
      codeSecond: 0,

      codeTimerFlag: null,
    }
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    themeColor() {
      if (this.theme == 1) {
        return '#cbb042';
      } else {
        return '#fc1a34';
      }
    },
  },
  methods: {
    closeDialog() {
      this.$emit('close');
    },
    codeButtonClicked() {
      let userPhone = this.userPhone.removeBlanks();
      if (userPhone == '') {
        this.$toast('请输入新手机号！');
        return;
      }
      if (!userPhone.isPhoneNumber()) {
        this.$toast('手机号格式不正确！');
        return;
      }
      let _this = this;
      this.$store.state.http.ajax.smsSend({
        tag: 'profile',
        phoneNumbers: userPhone
      },function (data) {
        if (data.code == 0) {
          _this.beginCodeTime();
        } else {
          _this.$toast('发送失败！');
        }
      }, function (data) {
          _this.$toast('发送失败，请重试！');
      })
    },
    beginCodeTime() {
      if (this.codeTimerFlag != null) {
        return;
      }
      this.codeSecond = 60;

      let _this = this;
      this.codeTimerFlag = setInterval(function () {
        _this.codeSecond --;
        if (_this.codeSecond <= 0) {
          _this.closeCodeTimer();
        }
      }, 1000);
    },
    closeCodeTimer() {
      if (this.codeTimerFlag != null) {
        clearInterval(this.codeTimerFlag);
        this.codeTimerFlag = null;
        this.codeSecond = 0;
      }
    },


    submitButtonClicked() {
      let pwd = this.userPwd.removeBlanks();
      if (pwd == '') {
        this.$toast('请输入密码！');
        return;
      }

      let userPhone = this.userPhone.removeBlanks();
      if (userPhone == '') {
        this.$toast('请输入新手机号！');
        return;
      }
      if (!userPhone.isPhoneNumber()) {
        this.$toast('手机号格式不正确！');
        return;
      }

      let code = this.userCode.removeBlanks();
      if (code == '') {
        _this.$toast('请输入验证码！');
        return;
      }
      let _this = this;

      this.$store.state.http.ajax.ucProfileUpdate({
        flag: 1,
        newMobile: userPhone,
        password: pwd,
        verificationCode: code
      },function (data) {
        let code = data.code;
        if (code == 0) {
          _this.$toast('提交成功！');
          let user = _this.user;
          if (user != null) {
            user.mobile = userPhone;
            _this.$store.commit('setUser', user);
          }
          setTimeout(function () {
            _this.closeDialog();
          }, 500);
        } else {

          if (code == 2) {
            _this.$toast('验证码有误！');
          } else if (code == 3) {
            _this.$toast("手机号已存在！");
          } else {
            _this.$toast('修改失败！');
          }
        }
      }, function (data) {
          _this.$toast('请求失败，请重试！');
      })
    },
  }
}
</script>

<style scoped>

  #setting_dialog_outer {
    position: fixed !important;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0,0,0,0.3);
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
  }

  #setting_dialog_outer > div {
    width: 90%;
    max-width: 800px;
    padding-top: 50px;
    padding-bottom: 80px;
    background-color: white;
    position: relative;
  }

  #setting_dialog_outer .close-button {
    text-decoration: none;
    position: absolute;
    top: 20px;
    right: 15px;
    display: block;
    z-index: 999;
  }

  #setting_dialog_outer .close-button > img {
    height: auto;
    width: 20px;
  }

  #phone_dialog {
    width: 100%;
    min-height: 150px;
    padding-left: 15px;
    padding-right: 15px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: nowrap;
  }

  .dialog-title {
    font-size: 1.5rem;
    color: #fc1a34;
    font-weight: bold;
  }

  #phone_dialog input {
    outline: none;
  }

  #phone_dialog .dialog-content {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: nowrap;
  }

  #phone_dialog .input-text {
    border: solid 1px #fc1a34;
    color: #333;
    text-indent: 15px;
    width: 82vw;
    border-radius: 20px;
    max-width: 400px;
    height: 30px;
    margin-top: 15px;
  }

  #phone_dialog .input-code-outer {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
  }

  #phone_dialog .input-code-outer > .input-button {
    width: 40%;
  }

  #phone_dialog .input-code {
    color: #333;
    border: solid 1px #fc1a34;
    text-indent: 15px;
    width: 50%;
    border-radius: 20px;
    max-width: 250px;
    height: 30px;
    margin-top: 15px;
  }

  #phone_dialog .input-button {
    background-color: #fc1a34;
    border: none;
    font-size: 1rem;
    border-radius: 20px;
    height: 30px;
    color: white;
    padding: 3px 0;
    font-weight: bold;
    text-align: center;
    width: 80%;
    margin-top: 15px;
  }

  @media screen and (min-width: 768px) {

  }

</style>



// WEBPACK FOOTER //
// src/components/settings/BingPhoneNumber.vue